import src from "IMAGE";
export default { src, width: 300, height: 128, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAS0lEQVR42mXLOQ6AIBRF0b//WrZgZeMK1NLEaCicQsIYCAns4UH/i9udS+N+448WqQZWKB4kFonpeKCzY+A0GjR0IFaJ7VPsnq8XDYqoVWHX+hDdAAAAAElFTkSuQmCC"};
